import React, { useState, useEffect, useCallback } from "react";
import { Select, Input } from "antd";
import { CheckEmailExist, UpdateUser, UserInfo } from "../../../../Auth/Helper";
import MyEditor from "../../../../../Components/TextEditor";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api, { baseURL } from "../../../../../Utils/api";
import ConnectionProvider, {
  useConnectionProvider,
} from "../../../../../Providers/Consultant/Connection";
import Back from "../../../../../Components/Back";
import SimpleBackdrop from "../../../../../Components/SimpleBackDrop";
import JobProvider, {
  useJobProvider,
} from "../../../../../Providers/Consultant/Jobs";
import { useCommonUserProvider } from "../../../../../Providers/Common/User";
import { roles, s3Url } from "../../../../../Utils/constants";
import { useCountryStateCityProvider } from "../../../../../Providers/Common/CountyStateCity";
import { Controller, useForm } from "react-hook-form";
import { Button as MUIButton } from "@mui/material";
import UserProfileAvatar from "../../../../../Components/UserProfileAvatar";

const userObj = {
  id: "",
  name: "",
  email: "",
  company: "",
  country: "",
  phone: "",
  industryExperience: "",
  address: "",
  about: "",
  state: "",
  city: "",
  availability_hours: "",
  businessType: "",
  portfolio: "",
  linkedin: "",
  isAccountApproved: false,
  skills: [],
  resume: null,
};

const { id, ...userObjForAttributes } = userObj;

const EditConsultantProfile = ({ setIsProfileEditing }) => {
  const navigate = useNavigate();
  const {
    inviteVendor,
    fetchVendor,
    vendorRequest,
    fetchvendorRequests,
    loading,
  } = useConnectionProvider();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { skills: allSkills, getAllSkills } = useJobProvider();
  const { becomeHybridConsultant, getApprovalStatus } = useCommonUserProvider();
  const [Loading, SetLoading] = useState(false);
  const [vendorOnProlegion, setVendorOnProlegion] = useState("YES");
  const [selfEmployed, setSelfEmployed] = useState(false);
  const [isHybridConsultant, setIsHybridConsultant] = useState(false);
  const [approvedHybridConsultant, setApprovedHybridConsultant] = useState(false);
  const [vendor, setVendor] = useState(null);
  const [consultant, setConsultant] = useState({ ...userObj });
  const [emailUsed, setEmailUsed] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [updateCount, setUpdateCount] = useState(1);
  const [userAttributes, setUserAttributes] = useState({
    ...userObjForAttributes,
    userId: "",
  });

  useEffect(() => {
    async function fetchData() {
      UserInfo()
        .then((res) => {
          if (res && res.data.success) {
            const { firstName, lastName, username, ...rest } = res.data.result;
            const { id, ...restOfAttributes } = rest;
            console.log(res);
            setConsultant({
              ...consultant,
              ...rest,
              name: `${firstName} ${lastName}`,
              firstName: firstName,
              lastName: lastName,
              username: username,
              resume: rest.resume ? rest.resume : " ",
            });
            setUserAttributes({
              ...userAttributes,
              ...restOfAttributes,
              userId: id,
              firstName: firstName,
              lastName: lastName,
              username: username,
              name: `${firstName} ${lastName}`,
            });
            if (rest.country) getStatesByCountry(rest.country);
            if (rest.state && rest.country)
              getStatesByCountry(rest.country, rest.state);
            fetchvendorRequests();
            fetchVendor(id).then((data) => setVendor(data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
        getApprovalStatus().then((res)=>{
          if(res.data.success){
            if(res.data.status){
              //Request Approved
              setIsHybridConsultant(true);
              setApprovedHybridConsultant(true);
              setSelfEmployed(true);
            }else{
              //Awaiting Approval
              setIsHybridConsultant(true);
              setApprovedHybridConsultant(false);
            }
          }else{
            //Not a hybrid consultant
            setApprovedHybridConsultant(false);
            setIsHybridConsultant(false);
          }    
        }).catch((err)=>{
          console.log(err);
        })
      
    }

    getAllSkills();
    fetchData();
    getCountries();
  }, [refresh, updateCount]);

  const {
    countries,
    states,
    cities,
    getCountries,
    getStatesByCountry,
  } = useCountryStateCityProvider();

  // const {
  //   countries,
  //   states,
  //   cities,
  //   getCountries,
  //   getStatesByCountry,
  //   getCitiesByStateAndCountry,
  // } = useCountryStateCityProvider();

  const updateUserInfo = async () => {
    SetLoading(true);
    const updatedUser = await UpdateUser(userAttributes);
    if (updatedUser) {
      SetLoading(false);
      setRefresh(!refresh);
      Swal.fire({
        icon: "success",
        title: "Success",
        html: "User profile updated successfully<br />Click on OK to go back.",
        showCloseButton: true,
      }).then((val) => {
        if (val.isConfirmed) navigate('/dashboard/my-account');
      });
    } else {
      SetLoading(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const [inviteUser, setInviteUser] = useState({
    invitedBy: localStorage.getItem("userId"),
    name: "",
    email: "",
    role: roles.vendor,
  });

  const [requestUser, setRequestUser] = useState({
    email: "",
    username: "",
  });

  const handleInviteChange = (e, name) => {
    setInviteUser({
      ...inviteUser,
      id: localStorage.getItem("userId"),
      [name]: e?.target?.value || e,
    });
  };

  const handleRequestChange = (e, name) => {
    setRequestUser({
      ...requestUser,
      id: localStorage.getItem("userId"),
      requestFrom: "CONSULTANT",
      [name]: e?.target?.value || e,
    });
  };

  const checkEmailUsed = (email) => {
    CheckEmailExist({ email: email }).then((res) => {
      setEmailUsed(res?.data?.status);
      handleRequestChange(res?.data?.username, "username");
      handleRequestChange(email, "email");
    });
  };

  const requestVendor = async () => {
    api
      .post(`/user/requestvcm`, requestUser)
      .then((data) => {
        if (data.data.success) {
          fetchVendor(userAttributes.userId).then((data) => setVendor(data));
          Swal.fire({
            title: "Vendor Invited Successfully",
            icon: "success",
          });
        } else {
          Swal.fire({
            title: "Enter correct username and email",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
        });
        console.log(err);
      });
  };
  const acceptVendor = async (vendorId) => {
    const data = {
      vendor_id: vendorId,
      consultant_id: localStorage.getItem("userId"),
    };
    api
      .put(`${baseURL}/user/acceptinvitevcm?for=consultant`, data)
      .then((data) => {
        if (data.data.success) {
          fetchVendor().then((data) => setVendor(data));
          fetchvendorRequests();
          Swal.fire({
            title: "Vendor Approved",
            icon: "success",
          });
        } else {
          Swal.fire({
            title: "Some Error occurred",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
        });
        console.log(err);
      });
  };
  const rejectVendor = async (vendorId) => {
    const data = {
      vendor_id: vendorId,
      consultant_id: localStorage.getItem("userId"),
    };
    api
      .delete(`${baseURL}/user/declineinvitevcm?for=consultant`, { data })
      .then((data) => {
        if (data.data.success) {
          fetchVendor().then((data) => setVendor(data));
          fetchvendorRequests();
        } else {
          Swal.fire({
            title: "Some Error occurred",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
        });
        console.log(err);
      });
  };

  const setEditorData = useCallback(
    (resumeData) =>
      setUserAttributes({ ...userAttributes, resume: resumeData }),
    [userAttributes]
  );

  const updateAvatar = async (url) => {
      const updatedUser = await UpdateUser({
        keycloakId: consultant.keycloakId,
        profilePhoto: url,
      });
      setUpdateCount(updateCount+1)
      if (updatedUser) {
        setUserAttributes({
          ...userAttributes,
          profilePhoto: url,
        });

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your profile picture has been updated",
        });
      } else {
        throw new Error("Something went wrong");
      }
  };

  const onSubmit = (data) => {
    console.log(data);
    becomeHybridConsultant(data)
    .then((res) => {
      console.log(res);
      if (res.data.success) {
        Swal.fire("", "Request send to admin for Approval", "success");
        setRefresh(!refresh)
        } else {
          Swal.fire("", "Something went wrong !", "info");
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire("", "Something went wrong !", "error");
      });
  };

  return (
    <div className="bg-white my-4 p-4 mx-auto shadow-md rounded-md">
      <SimpleBackdrop open={loading} />
      <SimpleBackdrop open={Loading} />
      <div>
        <span
          onClick={() => navigate('/dashboard/my-account')}
          className="text-2xl"
          style={{ color: "#139588" }}
        >
          <Back onClick={() => navigate('/dashboard/my-account')} />
          Edit Profile
        </span>
        <hr className="mt-8" />
      </div>
      <UserProfileAvatar user={consultant} setUpdateCount={setUpdateCount} updateCount={updateCount} updateHandler={updateAvatar}/>
      <hr className="mt-8" />
      <div className="flex lg:flex-row flex-col lg:space-x-[17%]">
        <div>
          {/* <div className="flex flex-col">
            <span className="my-2 text-gray-700">Consultant Name</span>
            <Input
              onChange={(e) => {
                setUserAttributes({
                  ...userAttributes,
                  name: e.target.value,
                });
              }}
              placeholder={"Enter Name"}
              className="w-80 border-none -ml-2"
              value={userAttributes.username}
            />
          </div> */}
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">First Name</span>
            <Input
              readOnly
              className="w-80 border-none -ml-2"
              value={userAttributes.firstName}
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">Country</span>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(value, option) => {
                // setSelectedCountry(value);
                setUserAttributes({ ...userAttributes, country: value });
                getStatesByCountry(value);
              }}
              placeholder="Enter Country"
              options={countries.length > 0 && countries.map((country) => {
                return { value: country.iso2, label: country.name };
              })}
              value={userAttributes.country}
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">Contact Number</span>
            <Input
              onChange={(e) => {
                setUserAttributes({
                  ...userAttributes,
                  phone: e.target.value,
                });
              }}
              maxLength={13}
              placeholder={"Enter Number"}
              value={userAttributes.phone}
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">
              Total Experience (in years)
            </span>
            <Input
              type="number"
              onChange={(e) => {
                setUserAttributes({
                  ...userAttributes,
                  industryExperience: e.target.value,
                });
              }}
              placeholder={"Enter Duration"}
              value={userAttributes.industryExperience}
            />
          </div>
        </div>
        <div>
          {/* <div className="flex flex-col">
            <span className="my-2 text-gray-700">Email ID</span>
            <Input
              onChange={(e) => {
                setUserAttributes({
                  ...userAttributes,
                  email: e.target.value,
                });
              }}
              className="w-80 border-none -ml-2"
              placeholder={"Enter Email"}
              value={userAttributes.email}
            />
          </div> */}
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">Last Name</span>
            <Input
              readOnly
              className="w-80 border-none -ml-2"
              value={userAttributes.lastName}
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">State</span>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(value) => {
                // setSelectedState(value);
                setUserAttributes({
                  ...userAttributes,
                  state: value,
                });
                getStatesByCountry(userAttributes.country, value);
              }}
              placeholder={
                consultant.state && consultant.state[0].length > 0
                  ? consultant.state
                  : "Enter State"
              }
              options={states.length > 0 && states.map((individualstate) => {
                return {
                  value: individualstate.iso2,
                  label: individualstate.name,
                };
              })}
              value={userAttributes.state}
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">City</span>
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(value) => {
                setUserAttributes({
                  ...userAttributes,
                  city: value,
                });
              }}
              placeholder={
                consultant.city && consultant.city.length > 0
                  ? consultant.city
                  : "Enter City"
              }
              options={cities.map((individualstate) => {
                return {
                  value: individualstate.name,
                  label: individualstate.name,
                };
              })}
              value={userAttributes.city}
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">Availability</span>
            {/* <Input
              type="number"
              onChange={(e) => {
                setUserAttributes({
                  ...userAttributes,
                  availability_hours: value,
                });
              }}
              options={consultantAvailability}
              value={userAttributes.availability_hours}
              min={0}
              max={168}
              maxLength={3}
            /> */}
            <Select
              onChange={(value) => {
                setUserAttributes({
                  ...userAttributes,
                  availability_hours: value,
                });
              }}
              options={[
                { value: "AVAILABLE", label: "AVAILABLE" },
                { value: "PARTIAL", label: "PARTIAL" },
                { value: "NOTAVAILABLE", label: "NOT AVAILABLE" },
              ]}
              value={userAttributes.availability_hours}
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="mt-2">
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">Select Skills</span>
            {/* HACK: Change to uncontrolled component */}
            <Select
              mode="tags"
              placeholder="Please select"
              value={userAttributes.skills}
              onChange={(val) =>
                setUserAttributes({ ...userAttributes, skills: val })
              }
              options={allSkills.map(({ name }) => ({
                value: name,
                label: name,
              }))}
            />
          </div>
          <div className="flex flex-col">
            <span className=" text-gray-700 my-2">LinkedIn</span>
            <Input
              onChange={(e) => {
                setUserAttributes({
                  ...userAttributes,
                  linkedin: e.target.value,
                });
              }}
              placeholder={"Enter Linkedin"}
              value={userAttributes.linkedin}
            />
            <span className="text-gray-700 mb-2 mt-2">Resume</span>
            {consultant.resume && (
              <MyEditor updateRaw={setEditorData} html={consultant.resume} />
            )}
          </div>
        </div>
      </div>
      {
        approvedHybridConsultant ?
        (vendor ? (
          <div
            style={{
              background: "rgba(19, 149, 136, 0.2)",
              borderRadius: "16px",
            }}
            className="mt-4 p-4 flex flex-col space-y-2"
          >
            <div className="flex justify-between items-center">
              <span className="font-bold text-lg">Vendor Details</span>
              {vendor.isApproved ? (
                <span className="bg-[#2ebaa34d] p-1 rounded-md text-[#2ebaa3]">
                  Connected
                </span>
              ) : (
                vendor.requestFrom === "CONSULTANT" && (
                  <span className="bg-yellow-200 p-1 rounded-md text-yellow-500">
                    Requested
                  </span>
                )
              )}
            </div>
            <div>
              Vendor Name:{" "}
              <span className="text-gray-700">{vendor.vendor?.company}</span>
            </div>
            <div>
              Vendor Email:{" "}
              <span className="text-gray-700">{vendor.vendor?.email}</span>
            </div>
          </div>
        ):null)
        :
        <div>
          <div className="mt-4 overflow-hidden">
            <span
              className="text-xl"
              style={{
                color: "#139588",
              }}
            >
              Employer Details
            </span>
            {!vendor && (
              <>
                <div className="flex flex-col">
                  <span className=" text-gray-700 my-2">Employment Type</span>
                  <Select
                    defaultValue={isHybridConsultant ? "Self Employed" : "Employed"}
                    onChange={setSelfEmployed}
                    disabled={isHybridConsultant}
                    options={[
                      { value: false, label: "Employed" },
                      { value: true, label: "Self Employed" },
                    ]}
                  />
                </div>
              </>
            )}
          </div>
          {vendor ? (
            <div
              style={{
                background: "rgba(19, 149, 136, 0.2)",
                borderRadius: "16px",
              }}
              className="mt-4 p-4 flex flex-col space-y-2"
            >
              <div className="flex justify-between items-center">
                <span className="font-bold text-lg">Vendor Details</span>
                {vendor.isApproved ? (
                  <span className="bg-[#2ebaa34d] p-1 rounded-md text-[#2ebaa3]">
                    Connected
                  </span>
                ) : (
                  vendor.requestFrom === "CONSULTANT" && (
                    <span className="bg-yellow-200 p-1 rounded-md text-yellow-500">
                      Requested
                    </span>
                  )
                )}
              </div>
              <div>
                Vendor Name:{" "}
                <span className="text-gray-700">{vendor.vendor?.company}</span>
              </div>
              <div>
                Vendor Email:{" "}
                <span className="text-gray-700">{vendor.vendor?.email}</span>
              </div>
            </div>
          ) : (
            !selfEmployed && !isHybridConsultant && (
              <div
                style={{
                  background: "rgba(19, 149, 136, 0.2)",
                  borderRadius: "16px",
                }}
                className="mt-4 p-4 w-full"
              >
                <div className="flex flex-col">
                  <span className="my-2 text-gray-700">Employer Email</span>
                  <Input
                    className="w-80"
                    placeholder="Enter Email"
                    onChange={(e) => {
                      checkEmailUsed(e.target.value);
                      if (emailUsed) {
                        handleRequestChange(e, "email");
                      } else {
                        handleInviteChange(e, "email");
                      }
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <span className="my-2 text-gray-700">Employer Name</span>
                  <Input
                    className="w-80"
                    placeholder="Enter Name"
                    onChange={(e) => handleRequestChange(e, "username")}
                  />
                </div>
                <button
                  onClick={() => {
                    if (emailUsed) {
                      requestVendor();
                    } else {
                      inviteVendor(inviteUser);
                    }
                  }}
                  className="text-sm px-2 mt-4"
                  style={{
                    height: "35px",
                    background: "#139588",
                    borderRadius: "5px",
                    color: "white",
                  }}
                >
                  Send Request
                </button>
              </div>
            )
          )}

          {selfEmployed && !isHybridConsultant && (
            <form className="pt-5" onSubmit={handleSubmit(onSubmit)}>
              <h1 className="text-lg font-semibold pt-2">
                Please provide the registration details
              </h1>
              <div className="grid grid-cols-2 gap-5">
                <div className="flex flex-col">
                  <span className=" text-gray-700 my-2">Company Name</span>
                  <Controller
                    name="company"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <Input {...field} placeholder={"Comapny Name"} />
                    )}
                  />
                  {errors.comapny_name && (
                    <p className="text-red-500 text-xs">
                      Company name is required
                    </p>
                  )}
                </div>
                <div className="flex flex-col">
                  <span className=" text-gray-700 my-2">Website</span>
                  <Controller
                    name="website"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <Input {...field} placeholder={"Website"} />
                    )}
                  />
                  {errors.website && (
                    <p className="text-red-500 text-xs">Website is required</p>
                  )}
                </div>
              </div>
              <div className="text-right pt-5">
                <MUIButton
                  type="submit"
                  variant="outlined"
                  style={{ textTransform: "unset", borderRadius: 6 }}
                >
                  Submit
                </MUIButton>
              </div>
            </form>
          )}
          {isHybridConsultant && !approvedHybridConsultant && (
            <div
              className="w-full p-4 rounded-xl text-center mt-5"
              style={{ backgroundColor: "rgba(19, 149, 136, 0.2)" }}
            >
              <h1>
                Your request has been submitted and the ProLegion staff will be
                validating and accepting it shortly.
              </h1>
            </div>
          )}

          <div className="mt-4 overflow-hidden">
            {vendorRequest.length > 0 && (
              <>
                <span
                  className="text-xl"
                  style={{
                    color: "#139588",
                  }}
                >
                  Vendor Requests
                </span>

                {vendorRequest.map((request) => {
                  return (
                    <div
                      style={{
                        background: "rgba(19, 149, 136, 0.2)",
                        borderRadius: "16px",
                      }}
                      className="mt-4 p-4 flex flex-col space-y-2"
                    >
                      <div className="flex justify-between items-center">
                        <span className="font-bold text-lg">Vendor Details</span>
                      </div>
                      <div>
                        Vendor Name:{" "}
                        <span className="text-gray-700">
                          {request.vendor?.company}
                        </span>
                      </div>
                      <div>
                        Vendor Email:{" "}
                        <span className="text-gray-700">
                          {request.vendor?.email}
                        </span>
                      </div>
                      <div className="flex flex-row justify-end mt-4 space-x-4">
                        <button
                          onClick={() => rejectVendor(request.vendor_id)}
                          className="sm:mt-0 mt-4 text-sm space-x-8 px-2 bg-red-300 text-red-700"
                          style={{
                            height: "35px",
                            borderRadius: "5px",
                          }}
                        >
                          Reject
                        </button>
                        <button
                          onClick={() => acceptVendor(request.vendor_id)}
                          className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
                          style={{
                            height: "35px",
                            background: "#139588",
                            borderRadius: "5px",
                            color: "white",
                          }}
                        >
                          Approve
                        </button>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>

      }
      <div className="flex flex-row justify-end mt-4 space-x-4">
        <button
          onClick={() => {
            navigate("/dashboard/my-account");
          }}
          className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
          style={{
            height: "35px",
            background: "white",
            borderRadius: "5px",
            border: " 0.5px solid #000000",
          }}
        >
          Discard Changes
        </button>
        <button
          onClick={() => updateUserInfo()}
          className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
          style={{
            height: "35px",
            background: "#139588",
            borderRadius: "5px",
            color: "white",
          }}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

const EditConsultantProfileWrapper = ({ setIsProfileEditing }) => {
  return (
    <ConnectionProvider>
      <JobProvider>
        <EditConsultantProfile setIsProfileEditing={setIsProfileEditing} />
      </JobProvider>
    </ConnectionProvider>
  );
};

export default EditConsultantProfileWrapper;
